<!--
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-07-25 21:35:58
 * @LastEditTime: 2021-12-01 19:03:10
 * @LastEditors: lkz
 -->
<template>
  <div id="addAfter">
    <div class="max-hei">
      <el-form :label-position="labelPosition" label-width="80px" ref="shouhouQueryFrom">
        <el-form-item label="订单号">
          <el-input style="width: 230px" v-model="orderId" placeholder="请输入订单号"></el-input>
          <el-button class="btns" size="mini" type="primary" @click="getOrderId(orderId, 1)">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- 商品信息 -->
      <div class="goods-wrapper">
        <table class="googs_table">
          <thead>
            <tr>
              <th align="center" style="padding: 10px 0; background: #f2f2f2">商品信息</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in itemList" :key="index">
            <tr>
              <td>
                <div class="elradio" :class="{ centeradio: item.itemType !== 1 }">
                  <!-- item.itemType != 1   :disabled='item.checked || item.checked == undefined' -->
                  <el-radio v-model="itemId" :label="item.subOrderId" @change="setitems(item, 1, index)"
                    v-if="item.accessories != 1" :disabled="item.checked" style="padding-top: 22px">
                  </el-radio>
                  <i class="el-icon-caret-bottom" :class="{ active: !item.showbtn }" v-if="item.itemType == 1"
                    @click="; (item.showbtn = !item.showbtn), getulist(item, index)">
                  </i>
                </div>
                <div class="goods-info-wrapper">
                  <div style="position: relative">
                    <img :src="item.itemImg" alt="" />
                    <p class="zengpin" v-if="item.accessories == 1">赠品</p>
                    <p class="zengpin" v-if="item.accessories != 1 && item.checked">已售后</p>
                  </div>
                  <div class="goods-info">
                    <h4 :style="{ marginBottom: showIdentity(item.subOrderId) ? '0' : '20px' }">
                      <span>{{ item.itemName }}</span><label>￥{{ item.itemPrice }}</label>
                    </h4>
                    <!-- 超期标识 -->
                    <span v-if="showIdentity(item.subOrderId)" class="identity_item">已售后超期</span>
                    <p :style="{ marginTop: showIdentity(item.subOrderId) ? '0' : '20px' }">
                      <span>规格：{{ item.itemModel }}</span><label>x{{ item.buyCount }}</label>
                    </p>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-for="(itemT, indexT) in item.itemList2" :key="indexT" v-show="item.showbtn">
              <td>
                <div class="elradio">
                  <el-radio v-model="itemId" :label="itemT.subOrderId" style="padding-top: 40px" :disabled="itemT.checked || item.disabledTuCheckd"
                    @change="setitems(item, 2, indexT)"></el-radio>
                </div>
                <div class="goods-info-wrapper">
                  <div style="position: relative">
                    <img :src="itemT.itemImg" alt="" />
                    <p class="zengpin" v-if="itemT.checked">已售后</p>
                  </div>
                  <div class="goods-info">
                    <h4 :style="{ marginBottom: itemT.isIdentity ? '0' : '20px' }">
                      <span>{{ itemT.itemName }}</span><label>￥{{ itemT.itemPrice }}</label>
                    </h4>
                    <!-- 超期标识 -->
                    <span v-if="itemT.isIdentity" class="identity_item">已售后超期</span>
                    <p :style="{ marginTop: itemT.isIdentity ? '0' : '20px' }">
                      <span>规格：{{ itemT.itemModel }}</span><label>x{{ itemT.buyCount }}</label>
                    </p>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 新增售后表单 -->
      <el-form :label-position="labelPosition" :model="afterSaleForm" :rules="rules" label-width="100px"
        ref="afterSaleForm" v-show="listStatus" style="margin-top: 20px">
        <el-form-item label="售后类型" prop="refundType">
          <el-select v-model="afterSaleForm.refundType" placeholder="请选择"
            @change="setRefundType(1, afterSaleForm.refundType)">
            <el-option v-for="(item, index) in refundTypeList" :key="index" :label="item.value"
              :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货物状态" prop="receivedStatus">
          <el-select v-model="afterSaleForm.receivedStatus" placeholder="请选择" @change="setRefundType(2)">
            <el-option v-for="(item, index) in receivedStatusList" :key="index" :label="item.value"
              :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后原因" prop="refundReasonList">
          <el-select v-model="afterSaleForm.refundReasonList" placeholder="请选择"
            @change="setRefundType(3, afterSaleForm.refundReasonList)">
            <el-option v-for="(item, index) in returnTypeList" :key="index" :label="item.reasonName"
              :value="item.refundReason"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后数量" prop="itemCanReturnNum">
          <span style="cursor: pointer" @click="addReturnNum(1)"> <i class="el-icon-minus"></i></span>
          <el-input class="itemNumber" v-model="afterSaleForm.itemCanReturnNum" disabled></el-input>
          <span style="cursor: pointer" @click="addReturnNum(2)"> <i class="el-icon-plus"></i></span>
        </el-form-item>
        <el-form-item label="卡券账号" prop="cardCouponNoList" v-if="cardCouponBeanList && cardCouponBeanList.length">
          <el-select v-model="afterSaleForm.cardCouponNoList" multiple collapse-tags placeholder="请选择"
            style="width: 240px">
            <el-option v-for="(item, index) in cardCouponBeanList" :key="index" :value="item.cardNo">
              {{ item.cardNo + '(' + item.cardStatusDesc + ')' }}
            </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="社群奖励" prop="notDeductCommission" v-show="afterSaleForm.showCommissionOption">
          <el-checkbox v-model="afterSaleForm.notDeductCommission"
            :disabled="!updateAuthDeductCommission">不扣减</el-checkbox>
        </el-form-item>
        <!-- <el-form-item label="扣除金额" prop="refundAmount" v-if="!isReplenishment">
            <el-input style="width:80px;" v-model="afterSaleForm.refundAmount" @blur="checvaluev3"></el-input>
            <span style='margin-left:10px;color:#999999'>（应退金额: {{afterSaleForm.refundableMoney}}）</span>
          </el-form-item> -->
        <el-form-item label="实退金额" v-if="!isReplenishment" prop="returnMoney">
          <span>￥<el-input style="width: 80px" v-model.trim="afterSaleForm.returnMoney" :disabled="returnMoneyDisable"></el-input>
            <!-- 退款明细 -->
            <refundAmountDetails ref="refundAmountDetails" @getRefundAmountDetails="getRefundAmountDetails">
            </refundAmountDetails>
            （包含：退税费：{{ afterSaleForm.returnTaxMoney }} + 退运费{{ afterSaleForm.wuliuFee }}）
          </span>
        </el-form-item>
        <el-form-item label="商品规格" prop="specificationList" v-if="isBarter">
          <el-select v-model="afterSaleForm.specificationList" placeholder="请选择">
            <el-option v-for="(item, index) in specificationOption" :key="index" :label="item.value" :title="item.value"
              :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货地址" prop="address" v-if="isReplenishment">
          <span>
            {{ afterSaleForm.address.receiverName }}&nbsp;&nbsp;&nbsp;
            {{ afterSaleForm.address.receiverPhone }}&nbsp;&nbsp;&nbsp;
            {{ afterSaleForm.address.receiverProvince }}
            {{ afterSaleForm.address.receiverCity }}
            {{ afterSaleForm.address.receiverArea }}
            {{ afterSaleForm.address.receiverStreet }}
            {{ afterSaleForm.address.receiverAddress }}
          </span>
          <div class="edit" @click="editAddress">修改地址</div>
        </el-form-item>
        <Address :dialogVisible="dialogVisible" :userForm="afterSaleForm.address" @closeBtn="closeBtn"
          @submitBtn="submitBtn"></Address>
        <el-form-item class="skill-input-wrapper" label="原因描述:" :prop="commentRequired" :key="commentRequired">
          <ElInput type="textarea" v-model="afterSaleForm.dealtNote" :rows="4" :maxlength="200" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item class="skill-input-wrapper" label="图片地址:">
          <work-upload @uploadImg="workImgs"></work-upload>
        </el-form-item>
        <el-form-item label="图片凭证" :prop="imgRequired" :key="imgRequired">
          <div class="upload-box">
            <div class="imgList">
              <span v-for="(item, index) in afterSaleForm.operatorRefundImgs" :key="index">
                <img :src="item" alt="" @click="showimg(index)" />
                <i class="el-icon-error" @click="delbtnpic(index)"></i>
              </span>
            </div>
            <el-upload v-show="afterSaleForm.operatorRefundImgs && afterSaleForm.operatorRefundImgs.length < 5"
              style="display: inline; margin-right: 5px"
              action="/yunjixinyunadmin/admin/xinyun/upload/uploadPic_json.json" list-type="picture-card" name="data"
              :drag="true" accept=".jpg,.png" :on-success="handlePictureCardPreview" :show-file-list="false">
              <div class="upload-item">
                <i class="el-icon-plus"></i>
                <span class="text">上传图片</span>
              </div>
            </el-upload>
            <videoUpload v-model="afterSaleForm.refundVideo.url" :size="videoSize" :accept="videoFormatList.join(',')"
              :uploadUrl="uploadUrl"></videoUpload>
          </div>

          <div class="line-tip">最多支持5张，图片仅支持jpg和png格式，单张图片不要超过5M，上传1条视频。</div>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer" v-show="listStatus">
      <el-button type="primary" @click="submitShouhouForm('afterSaleForm')">确认创建</el-button>
      <el-button @click="resetShouhouForm" v-if="this.$route.query.orderId">取消</el-button>
    </div>
    <el-dialog title="请你确认是否申请售后" width="480px" top="50px" :visible.sync="dialogFormVisible2"
      :before-close="resetShouhouForm2" :close-on-click-modal="false">
      <div class="quedingshouhou">
        <h4>{{ confirmdata.title }}</h4>
        <ul>
          <li v-for="(item, index) in confirmdata.list" :key="index">
            <img :src="item.image" alt="" />
            <p :title="item.name" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
              {{ item.name }}
            </p>
            <p>{{ item.model }}</p>
            <p>{{ item.price }} x {{ item.count }}</p>
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitShouhouRequest()" v-preventReClick>确认</el-button>
        <el-button @click="resetShouhouForm2">取消</el-button>
      </div>
    </el-dialog>
    <viewer :images="afterSaleForm.operatorRefundImgs" ref="viewerRef" :options="{ title: false }">
      <img v-show="false" v-for="(src, index) in afterSaleForm.operatorRefundImgs" :src="src" :key="index" />
    </viewer>
    <!-- 同图弹窗 -->
    <figureDialog ref="figureDialog" @handleSave="handleSave" @cellClick="cellClick" :title="'确认提示'" :dialogtype="1">
    </figureDialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ImgGroupUpload from '@ui/manage/ImgGroupUpload'
import cache from '@/utils/formCache'
import Viewer from 'v-viewer/src/component.vue'
// 同图弹窗
import figureDialog from '@/views/invoices/voucher/addCompensate/figureDialog'
import * as filter from '@core/filters'
import videoUpload from '@/components/videoUpload'
import refundAmountDetails from '../../../refundAmountDetails'
import * as http from './addAfter.service' // GET POST, DELETE, PUT,
import Address from './address'
import workUpload from '../../../invoices/components/workUpload'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'viewerjs/dist/viewer.css'

export default {
  name: 'addAfter',
  props: {
    sumbit: {
      type: Function
    }
  },
  data() {
    const numReg = /(^\d+\.?\d{1,2}|^\d+)$/
    const checkMoney = (rule, value, callback) => {
      if (value === null || value === undefined || value === '') {
        callback(new Error('请输入实退金额'))
      } else if (!numReg.test(value)) {
        callback(new Error('实退金额只能为正数,最多2位小数'))
      } else if (!this.fillZero && value <= 0) {
        callback(new Error('实退金额需大于0！'))
      } else if (value > this.totalAbleMoney) {
        callback(new Error('实退金额不能大于最大可退金额！'))
      } else {
        callback()
      }
    }
    return {
      videoFormatList: ['.mkv', '.mp4'], // 视频格式
      videoSize: 100 * 1024 * 1024, // 视频大小
      uploadUrl: filter.getUploadHost('/cdnadmin/admin/upload/uploadFile_json'),
      oldBarcode: '', // 原商品barcode
      isBarter: false, // 默认不显示商品规格和收货地址，当选择售后类型为换货显示
      isReplenishment: false, // 默认不显示商品规格和收货地址，当选择售后类型为换货，补发显示
      dialogVisible: false, // 地址弹窗开关
      labelPosition: 'right',
      orderId: '', // 订单号
      itemId: '', // 商品ID
      itemList: [],
      cardCouponBeanList: [], // 卡券列表
      refundTypeList: [], // 售后类型列表
      returnTypeList: [], // 售后原因列表
      receivedStatusList: [], // 货物状态列表
      specificationOption: [
        { key: 1, value: '' },
        { key: 2, value: '' }
      ], // 商品规格列表
      afterSaleForm: {
        cardCouponNoList: [], // 卡券类型
        refundType: '', // 售后类型
        receivedStatus: '', // 货物状态
        refundReasonList: '', // 售后原因
        itemCanReturnNum: '', // 售后数量
        notDeductCommission: false, // boss收益
        showCommissionOption: false, // 展示boss收益
        // refundAmount: '0', // 退款金额
        refundableMoney: '', // 应退金额
        returnMoney: '', // 实退金额
        returnTaxMoney: '', // 退税费
        wuliuFee: '', // 退物流费
        dealtNote: '', // 客服说明
        operatorRefundImgs: [], // 图片凭证
        specificationList: '', // 商品规格
        refundVideo: {
          url: '',
          img: ''
        },
        address: {
          receiverName: '',
          receiverPhone: '',
          receiverProvince: '',
          receiverCity: '',
          receiverArea: '',
          receiverStreet: '',
          receiverAddress: ''
        } // 省市区展示
      },
      rules: {
        cardCouponNoList: [{ required: true, message: '请选择卡券号码', trigger: 'change' }],
        refundType: [{ required: true, message: '请选择售后类型', trigger: 'change' }],
        refundReasonList: [{ required: true, message: '请选择售后原因', trigger: 'change' }],
        receivedStatus: [{ required: true, message: '请选择货物状态', trigger: 'change' }],
        itemCanReturnNum: [{ required: true, message: '请输入售后数量', trigger: 'blur' }],
        // refundAmount: [
        //   { required: true, message: '请输入退款金额', trigger: 'blur' }
        // ],
        dealtNote: [{ required: true, message: '请填写退款说明', trigger: 'blur' }],
        operatorRefundImgs: [
          {
            type: 'array',
            required: true,
            message: '请选择至少上传一张凭证图片',
            trigger: 'change'
          }
        ],
        specificationList: [{ required: true, message: '请选择商品规格', trigger: 'change' }],
        address: [{ required: true, message: '请选择收货地址', trigger: 'change' }],
        returnMoney: [{ required: true, validator: checkMoney, trigger: 'blur' }]
      },
      getitemdata2: {},
      getitemdata: {},
      v3json: {},
      setlist: [],
      dialogFormVisible2: false,
      confirmdata: {
        title: '商品因合并清关、"N元X件和跨境"活动若申请售后以下商品需同时申请',
        list: []
      },
      showFrame: 1,
      showActivityWindows: 1,
      showYjzmWindows: 1,
      refundDatas: {}, // 参数
      refundIndex: '',
      listStatus: false, // 默认隐藏页面表单
      showbtn: true,
      commentRequired: '',
      imgRequired: '',
      Butiantype: '',
      refundYuanyin: {},
      refundCommonReplaceDetail: {
        itemId: '',
        barcode: '',
        refundReceiverInfoVo: {
          receiverName: '',
          receiverPhone: '',
          receiverProvince: '',
          receiverCity: '',
          receiverArea: '',
          receiverStreet: '',
          receiverAddress: ''
        }
      },
      dialogVisibleImg: false,
      dialogImageUrl: '',
      // 获取父级传递的subOrderId
      subOrderIdIdentify: '',
      // 当前TU或者sku是否存在已售后
      haveafterList: [],
      updateAuthDeductCommission: false,
      itemTotalPrice: 0, // 实退总金额
      totalAbleMoney: 0, // 最大可输入金额
      fillZero: true, // true就是能输入0，false不能输入0
      identityList: [],
      cacheResult: {} ,// 缓存的副本，不可以修改,
      returnMoneyDisable: false //退款金额是否只读
    }
  },
  components: {
    ImgGroupUpload,
    Address,
    workUpload,
    Viewer,
    refundAmountDetails,
    figureDialog,
    videoUpload
  },
  computed: {
    ...mapState({
      arrlist: state => state.work.arrlist,
      index: state => state.work.index,
      topfont: state => state.work.topfont,
      nowlist: state => state.work.nowlist,
      empIds: state => state.work.empIds,
      setclear: state => state.work.setclear,
      sessdatas: state => state.sessdatas
    })
  },
  mounted() {
    if (this.$route.query.orderId) {
      this.getOrderId()
      this.Butiantype = this.$route.query.type
      this.subOrderIdIdentify = this.$route.query.subOrderId
    }
  },
  methods: {
    // 查询售后是否超时
    afterSaleIsMoreThanAllowApplyTime(orderId) {
      if (orderId) {
        http.afterSaleIsMoreThanAllowApplyTime({ orderId: orderId }).subscribe((res) => {
          this.identityList = res.data
        })
      }
    },
    // 打标识-超期
    showIdentity(subOrderId) {
      const result = this.identityList.filter(item => item.subOrderId === subOrderId)
      return result && result.length ? result[0].moreThanAllowApplyTimes : false
    },
    /**
     *打开选择地址
     */
    editAddress() {
      this.dialogVisible = true
    },
    // 关闭地址弹窗
    closeBtn() {
      this.dialogVisible = false
    },
    // 地址弹窗数据提交
    submitBtn(form) {
      this.afterSaleForm.address = form
      this.refundCommonReplaceDetail.refundReceiverInfoVo = form
      this.dialogVisible = false
    },
    /** 显示新增模态框，获取orderId,根据订单号查询订单信息 * */
    async getOrderId(orderId, type, subOrderId, tuOrderId) {
      // 重新搜索清空数据start
      this.itemList = []
      this.getitemdata = {}

      // 重新搜索清空数据end
      this.orderId = orderId || this.$route.query.orderId
      if (!this.orderId) {
        this.$alert('请输入订单号查询', '提示', {
          confirmButtonText: '确定',
          callback: () => { }
        })
        return
      }
      const api = async () => new Promise((resolve) => {
        http.createRefundCheck({ orderId: this.orderId }).subscribe((res) => {
          if (!res.response.data.canCreate) {
            this.$confirm(res.response.data.messages[0], '提示', {
              confirmButtonText: '仍然创建',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                http.returndetailBtJson({ orderId: this.orderId }).subscribe(
                  async (res) => {
                    if (type === 1) {
                      this.itemId = ''
                      this.specificationOption = ''
                      this.afterSaleForm.operatorRefundImgs = []
                      this.afterSaleForm.dealtNote = ''
                      // this.afterSaleForm.refundAmount = '0'
                      this.afterSaleForm.specificationList = ''
                      this.afterSaleForm.address = {}
                      this.isReplenishment = false
                      this.isBarter = false
                      this.listStatus = false
                    } else {
                      this.listStatus = true
                    }
                    let disabledTuCheckd = res.data.order.nationalSubsidyStatus===1
                    const json = []
                    res.data.order.itemList.forEach((j) => {
                      j.showbtn = false
                      if (j.tuDetails && j.tuDetails.length) {
                        // j.itemType = 1
                        j.itemList2 = []
                      }
                      j.disabledTuCheckd = disabledTuCheckd
                      json.push(j)
                    })
                    json.forEach((i) => {
                      if (res.data.alreadyReturnList && res.data.alreadyReturnList.length) {
                        res.data.alreadyReturnList.forEach((v) => {
                          if (i.subOrderId === v.subOrderId) {
                            i.checked = true
                          }
                          // if (v.isDelivered === '0') { // 0代表未发货 1代表已发货
                          //   i.itemType = 2
                          // }
                        })
                      }
                      // Tu下得sku是否已售后
                      if (
                        i.tuDetails
                          && i.tuDetails.length
                          && res.data.alreadyReturnList
                          && res.data.alreadyReturnList.length
                      ) {
                        i.tuDetails.forEach((x) => {
                          res.data.alreadyReturnList.forEach((z) => {
                            if (x.subOrderId === z.subOrderId) {
                              x.checked = true
                            }
                          })
                        })
                      }
                    })
                    // 判断是否是TU并且是否已发货
                    let injectItem = {}
                    let injectKey = -1
                    json.forEach((i, k) => {
                      if (res.data.deliveredList) {
                        res.data.deliveredList.forEach((j) => {
                          // 首选判断是否是TU
                          if (i.tuDetails && i.tuDetails.length) {
                            // isDelivered: 0代表未发货 1代表已发货
                            if (i.barcode === j.barCode && j.isDelivered === '1') {
                              i.itemType = 1
                              console.log(subOrderId === j.subOrderId, subOrderId, j.subOrderId, k)
                              if (subOrderId === j.subOrderId) {
                                console.log(i, j)
                                i.showbtn = true
                                injectItem = i
                                injectKey = k
                              }
                            }
                          }
                        })
                      }
                    })
                    this.haveafterList = res.data.alreadyReturnList
                    this.itemList = json
                    if (injectItem && injectKey > -1) {
                      await this.getulist(injectItem, injectKey)
                    }
                    // 默认打开选中勾选框
                    json.forEach(async (i, j) => {
                      // 从父级传进来的subOrderId和当前的一样并且没有售后不是赠品，则默认选中
                      if (i.subOrderId === this.subOrderIdIdentify && i.accessories !== 1 && !i.checked) {
                        this.itemId = this.subOrderIdIdentify
                        await this.setitems(i, 1, j)
                        resolve()
                      } else if (i.tuDetails && i.tuDetails.length) {
                        i.tuDetails.forEach(async (v, x) => {
                          if (v.subOrderId === this.subOrderIdIdentify && v.accessories !== 1 && !v.checked) {
                            this.itemId = this.subOrderIdIdentify
                            await this.setitems(i, 2, x)
                            resolve()
                          }
                        })
                      }
                    })
                  },
                  (error) => {
                    this.$message({
                      showClose: 'true',
                      message: error.responseText,
                      type: 'error'
                    })
                  }
                )
              })
              .catch(() => { })
          } else {
            http.returndetailBtJson({ orderId: this.orderId }).subscribe(
              async (res) => {
                if (type === 1) {
                  this.itemId = ''
                  this.specificationOption = ''
                  this.afterSaleForm.operatorRefundImgs = []
                  this.afterSaleForm.dealtNote = ''
                  // this.afterSaleForm.refundAmount = '0'
                  this.afterSaleForm.specificationList = ''
                  this.afterSaleForm.address = {}
                  this.isReplenishment = false
                  this.isBarter = false
                  this.listStatus = false
                } else {
                  this.listStatus = true
                }
                const json = []
                let disabledTuCheckd = res.data.order.nationalSubsidyStatus===1
                res.data.order.itemList.forEach((j) => {
                  j.showbtn = false
                  if (j.tuDetails && j.tuDetails.length) {
                    // j.itemType = 1
                    j.itemList2 = []
                  }
                  j.disabledTuCheckd = disabledTuCheckd
                  json.push(j)
                })
                json.forEach((i) => {
                  if (res.data.alreadyReturnList && res.data.alreadyReturnList.length) {
                    res.data.alreadyReturnList.forEach((v) => {
                      if (i.subOrderId === v.subOrderId) {
                        i.checked = true
                      }
                      // if (v.isDelivered === '0') {
                      //   i.itemType = 2
                      // }
                    })
                  }
                  // Tu下得sku是否已售后
                  if (
                    i.tuDetails
                      && i.tuDetails.length
                      && res.data.alreadyReturnList
                      && res.data.alreadyReturnList.length
                  ) {
                    i.tuDetails.forEach((x) => {
                      res.data.alreadyReturnList.forEach((z) => {
                        if (x.subOrderId === z.subOrderId) {
                          x.checked = true
                        }
                      })
                    })
                  }
                })
                // 判断是否是TU并且是否已发货
                let injectItem = {}
                let injectKey = -1
                json.forEach((i, k) => {
                  if (res.data.deliveredList) {
                    res.data.deliveredList.forEach((j) => {
                      // 首选判断是否是TU
                      if (i.tuDetails && i.tuDetails.length) {
                        // isDelivered: 0代表未发货 1代表已发货
                        if (i.barcode === j.barCode && j.isDelivered === '1') {
                          i.itemType = 1
                          console.log(subOrderId === j.subOrderId, subOrderId, j.subOrderId, k)
                          if (subOrderId === j.subOrderId) {
                            console.log(i, j)
                            i.showbtn = true
                            injectItem = i
                            injectKey = k
                          }
                        }
                      }
                    })
                  }
                })
                this.haveafterList = res.data.alreadyReturnList
                this.itemList = json
                if (injectItem && injectKey > -1) {
                  await this.getulist(injectItem, injectKey)
                }
                // 默认打开选中勾选框
                json.forEach(async (i, j) => {
                  // 从父级传进来的subOrderId和当前的一样并且没有售后不是赠品，则默认选中
                  if (i.subOrderId === this.subOrderIdIdentify && i.accessories !== 1 && !i.checked) {
                    this.itemId = this.subOrderIdIdentify
                    await this.setitems(i, 1, j)
                    resolve()
                  } else if (i.tuDetails && i.tuDetails.length) {
                    i.tuDetails.forEach(async (v, x) => {
                      if (v.subOrderId === this.subOrderIdIdentify && v.accessories !== 1 && !v.checked) {
                        this.itemId = this.subOrderIdIdentify
                        await this.setitems(i, 2, x)
                        resolve()
                      }
                    })
                  }
                })
              },
              (error) => {
                this.$message({
                  showClose: 'true',
                  message: error.responseText,
                  type: 'error'
                })
              }
            )
          }
          this.$nextTick(() => {
            this.getRefundApplyAutoFillPage(this.cacheResult)
          })
        })
      })
      await api()
      return true
    },
    /**
     * 图片上传返回参数
     */
    handleSuccess(file) {
      this.afterSaleForm.operatorRefundImgs = JSON.parse(JSON.stringify(file))
    },
    /** 根据订单号查询订单信息 */
    getOrderInfo(orderId, subOrderId) {
      this.afterSaleIsMoreThanAllowApplyTime(orderId)
      // 获取subOrderId
      this.subOrderIdIdentify = subOrderId
      const cacheData = cache.queryCache({
        // 获取缓存
        id: orderId + subOrderId,
        formId: 'addAfter'
      })
      // 拷贝一个缓存的副本
      this.cacheResult = Object.freeze(cacheData)
      if (cacheData && cacheData.cacheDetails.refundTypeList.length) {
        this.orderId = orderId
        this.afterSaleForm = cacheData.cacheParams
        // this.itemList = cacheData.cacheDetails.itemList // 缓存商品表格数据
        this.cardCouponNoList = cacheData.cacheDetails.cardCouponNoList // 缓存卡券号码列表
        this.refundCommonReplaceDetail = cacheData.cacheDetails.refundCommonReplaceDetail // 缓存换货地址
        this.refundTypeList = cacheData.cacheDetails.refundTypeList // 缓存售后类型枚举
        this.receivedStatusList = cacheData.cacheDetails.receivedStatusList // 缓存货物状态枚举
        this.returnTypeList = cacheData.cacheDetails.returnTypeList // 缓存售后原因枚举
        this.specificationOption = cacheData.cacheDetails.specificationOption // 缓存商品规格枚举
        this.isBarter = cacheData.cacheDetails.isBarter // 规格隐藏显示
        this.isReplenishment = cacheData.cacheDetails.isReplenishment // 补发商品规格和地址是否显示
        this.itemId = cacheData.cacheDetails.itemId // 缓存默认选中
        this.refundDatas = cacheData.cacheDetails.refundDatas // 缓存售后类型参数
        this.v3json.itemCanReturnNum = cacheData.cacheDetails.itemCanReturnNum
        this.v3json.itemMinCanReturnNum = cacheData.cacheDetails.itemMinCanReturnNum
        this.updateAuthDeductCommission = cacheData.cacheDetails.updateAuthDeductCommission // 是否有权限
        this.returnMoneyDisable = cacheData.cacheDetails.returnMoneyDisable
        this.getOrderId(orderId)
        // 获取售后超时信息进行打标
        return
      }
      this.getOrderId(orderId, 1)
    },
    // 判断有缓存 则售后申请自动填充数据  无缓存的情况cacheData 为false
    getRefundApplyAutoFillPage(cacheData) {
      return new Promise((resolve, reject) => {
        if (cacheData && cacheData.cacheParams) {
          const { cacheParams } = cacheData
          const params = {
            orderId: this.orderId, // 单号
            frontRefundType: cacheParams.refundType, // 售后类型
            receivedStatus: cacheParams.receivedStatus, // 收货状态
            refundReason: cacheParams.refundReasonList, // 售后原因
            realRefundMoneyAfter: cacheParams.returnMoney, // //实退金额
            version: 5,
            customerDesc: cacheParams.dealtNote, // 售后 说明
            refundImgs: cacheParams.operatorRefundImgs ? cacheParams.operatorRefundImgs.join(',') : '', // 图片
            refundVideo: cacheParams.refundVideo && cacheParams.refundVideo.url ? JSON.stringify(cacheParams.refundVideo) : '', // 视频
            refundCommonApplyDetail: this.refundDatas.refundCommonApplyDetail
          }
          http.getRefundApplyAutoFillPage(params).subscribe((res) => {
            this.initForm(res)
            resolve()
          }, () => {
            reject()
          })
        }
      })
    },
    // 判断如果接口返回了默认值，则取接口的值做初始值，否则就设置缓存的值做默认值
    initForm(res) {
      if (res.response.data.errorCode === 0) {
        // 校验自动是否为空，全部为空则return出去
        const list = ['orderId', 'frontRefundType', 'receivedStatus', 'refundReasonList', 'customerDesc', 'currentRefundNum', 'returnMoney',
          'notDeductCommission', 'refundImgs', 'refundVideo']
        const isEmpty = this.isValueIsEmpty(res.response.data, list)
        if (!isEmpty) {
          return
        }
        const result = res.response.data.data
        this.afterSaleForm.refundType = result.frontRefundType // 售后类型
        this.afterSaleForm.receivedStatus = result.receivedStatus // 售后状态
        this.afterSaleForm.refundReasonList = result.refundReason// 售后原因
        this.afterSaleForm.itemCanReturnNum = result.currentRefundNum // 当前售后数量
        this.afterSaleForm.returnMoney = result.returnMoney // 实退金额
        this.afterSaleForm.customerDesc = result.customerDesc// 原因描述
        this.afterSaleForm.notDeductCommission = result.notDeductCommission // boss收益
        this.afterSaleForm.refundableMoney = result.refundableMoney // 应退金额
        this.afterSaleForm.operatorRefundImgs = result.refundImgs || [] // 图片
        this.afterSaleForm.refundVideo = result.refundVideo ? JSON.parse(result.refundVideo) : { url: '', img: '' }// 视频
        this.afterSaleForm.cardCouponNoList = result.cardCouponNoList// 卡券收益
        this.afterSaleForm.specificationList = result.specificationList // 商品规格
        this.afterSaleForm.returnTaxMoney = result.returnTaxMoney // 退税费
        this.afterSaleForm.wuliuFee = result.wuliuFee // 退物流费
        this.returnMoneyDisable = result.returnMoneyDisable //禁用修改退款金额
      } else if (res.response.data.errorCode === -50208) {
        // code=-50208 则只保留说明，图片 视频 其他都置空
        this.afterSaleForm = Object.assign(this.afterSaleForm, {
          cardCouponNoList: [], // 卡券类型
          refundType: '', // 售后类型
          receivedStatus: '', // 货物状态
          refundReasonList: '', // 售后原因
          itemCanReturnNum: '', // 售后数量
          notDeductCommission: false, // boss收益
          showCommissionOption: false, // 展示boss收益
          refundableMoney: '', // 应退金额
          returnMoney: '', // 实退金额
          returnTaxMoney: '', // 退税费
          wuliuFee: '', // 退物流费
          specificationList: '' ,// 商品规格
          returnMoneyDisable: false,// 禁用修改退款金额
        })
      }
    },
    // list里面的字段，只有data有一个不为空，则返回true，则取填充接口的值。否则取缓存
    isValueIsEmpty(data, list) {
      return list.some(i => data[i] !== null && data[i] !== '')
    },
    // 
    /** 提交新建售后 * */
    submitShouhouForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 如果用户上传了图片,则需要提交前判断是否同图的接口
          if (this.afterSaleForm.operatorRefundImgs && this.afterSaleForm.operatorRefundImgs.length) {
            this.$refs.figureDialog.getData({ bizId: this.afterSaleForm.operatorRefundImgs.join(','), type: 5 })
          } else {
            this.handleSave()
          }
        } else {
          return false
        }
        return false
      })
    },
    handleSave() {
      this.submitShouhouRequest()
    },
    // 补偿单号点击, 跳到不错详情
    cellClick(row) {
      this.$emit('cellClick', row)
    },
    /** 取消新建售后 * */
    resetShouhouForm() {
      this.afterSaleForm.operatorRefundImgs = []
      this.itemId = ''
      this.itemList = []
      this.getitemdata = {}
      this.$refs.afterSaleForm.resetFields()
      this.listStatus = false
      window.parent.postMessage(false, '*')
    },
    resetShouhouForm2() {
      this.dialogFormVisible2 = false
      this.showFrame = 1
    },
    getulist(item, index) {
      return new Promise((resolve) => {
        if (!item.showbtn) {
          resolve()
          return
        }
        const isIdentity = this.showIdentity(item.subOrderId)
        const datas = {
          orderId: this.orderId,
          tuCode: item.barcode
        }

        http.getTUItemByTU(datas).subscribe((res) => {
          // this.getitemdata = item
          this.itemList[index].itemList2 = res.data
          // TU下限制是否已售后
          this.itemList[index].itemList2.forEach((i) => {
            // 如果父级TU超期则默认下面的sku都展示超期
            i.isIdentity = isIdentity
            this.haveafterList.forEach((j) => {
              if (i.subOrderId === j.subOrderId) {
                i.checked = true
              }
            })
          })
          resolve()
        }, () => {
          resolve()
        })
      })
    },
    /** 提交新增售后的请求 * */
    submitShouhouRequest() {
      cache.removeCache({
        id: this.orderId + this.itemId,
        formId: 'addAfter'
      })
      this.dialogFormVisible2 = false
      if (!this.orderId) {
        this.$alert('请输入订单号查询', '提示', {
          confirmButtonText: '确定',
          callback: () => { }
        })
        return
      }
      const param = this.refundDatas
      param.refundImgs = this.afterSaleForm.operatorRefundImgs.join(',')
      param.customerDesc = this.afterSaleForm.dealtNote
      param.showFrame = this.showFrame
      param.showActivityWindows = this.showActivityWindows
      param.showYjzmWindows = this.showYjzmWindows
      param.refundCommonApplyDetail.returnNum = this.afterSaleForm.itemCanReturnNum
      if (this.afterSaleForm.refundVideo.url) {
        param.refundVideo = JSON.stringify({
          url: this.afterSaleForm.refundVideo.url,
          img: this.afterSaleForm.refundVideo.url ? `${this.afterSaleForm.refundVideo.url}?vframe/jpg/offset/1` : ''
        })
      }
      // param.refundCommonApplyDetail.deductionMoney = Number(this.afterSaleForm.refundAmount)
      // 当申请售后售后类型为换货时，取商品规格的barcode，否则都取原商品barcode
      if (this.afterSaleForm.refundType === 30) {
        this.refundCommonReplaceDetail.barcode = this.afterSaleForm.specificationList
      } else {
        this.refundCommonReplaceDetail.barcode = this.oldBarcode
      }
      param.refundCommonReplaceDetail = this.refundCommonReplaceDetail
      if (this.refundIndex === 2) {
        param.refundCommonApplyDetail.returnNum = 1
        param.refundCommonApplyDetail.refundCommonApplyTuDetailList[0].returnNum = this.afterSaleForm.itemCanReturnNum
        // param.refundCommonApplyDetail.refundCommonApplyTuDetailList[0].deductionMoney = Number(this.afterSaleForm.refundAmount)
      }
      if (this.afterSaleForm.cardCouponNoList && this.afterSaleForm.cardCouponNoList.length) {
        // 卡券详情
        param.refundCommonApplyDetail.cardCouponRefundReqList = []
        this.cardCouponBeanList.forEach((v) => {
          this.afterSaleForm.cardCouponNoList.forEach((j) => {
            if (v.cardNo === j) {
              param.refundCommonApplyDetail.cardCouponRefundReqList.push({
                cardNo: v.cardNo,
                barcode: v.barcode,
                status: v.cardStatus
              })
            }
          })
        })
      }
      // boss收益是否扣减
      param.notDeductCommission = this.afterSaleForm.showCommissionOption
        ? this.afterSaleForm.notDeductCommission
        : false
      // 填写的实退金额
      if (this.afterSaleForm.returnMoney < this.totalAbleMoney) {
        param.realRefundMoneyAfter = this.afterSaleForm.returnMoney
      }
      param.itemTotalPrice = this.itemTotalPrice
      param.version = 5
      if (typeof this.sumbit === 'function') {
        param.realRefundMoneyAfter = this.afterSaleForm.returnMoney
        this.sumbit(this.afterSaleForm, param)
        return
      }
      http.refundCommonApply(param).subscribe((res) => {
        if (res.response.data.businessResp && res.response.data.businessResp.businessCode === 10002) {
          this.dialogFormVisible2 = true
          this.confirmdata.title = res.response.data.businessResp.businessMagTitle
          this.confirmdata.list = res.response.data.businessResp.businessJsonMsg
          this.dialogFormVisible = false
          this.showFrame = 0
          return
        }
        if (res.response.data.businessResp && res.response.data.businessResp.businessCode === 10004) {
          this.$confirm(res.response.data.businessResp.businessMsg, '提示', {
            confirmButtonText: '继续申请',
            cancelButtonText: '我在想想',
            type: 'warning'
          })
            .then(() => {
              this.showActivityWindows = 0
              this.submitShouhouRequest()
            })
            .catch(() => {
              this.showActivityWindows = 1
            })
          return
        }
        if (res.response.data.businessResp && res.response.data.businessResp.businessCode === 101203) {
          this.$confirm(res.response.data.businessResp.businessMsg, '提示', {
            confirmButtonText: '继续申请',
            cancelButtonText: '我在想想',
            type: 'warning'
          })
            .then(() => {
              this.showYjzmWindows = 0
              this.submitShouhouRequest()
            })
            .catch(() => {
              this.showYjzmWindows = 1
            })
          return
        }
        this.$message({
          showClose: 'true',
          message: '操作成功！',
          type: 'success'
        })
        this.$emit('fatherMos')
        window.parent.postMessage(false, '*')
        this.getitemdata = {}
        this.getitemdata2 = []
        this.itemId = '' // 商品ID
        this.itemList = []
        this.itemList2 = []
        this.refundTypeList = [] // 售后类型列表
        this.returnTypeList = [] // 售后原因列表
        this.afterSaleForm.refundType = ''
        this.afterSaleForm.receivedStatus = ''
        this.afterSaleForm.refundReasonList = ''
        this.afterSaleForm.itemCanReturnNum = 0
        // this.afterSaleForm.refundAmount = '0'
        this.afterSaleForm.dealtNote = ''
        this.afterSaleForm.operatorRefundImgs = []
        this.listStatus = false
        this.showActivityWindows = 1
      })
    },
    // 修改数量
    addReturnNum(type) {
      if (type === 1) {
        if (this.afterSaleForm.itemCanReturnNum <= this.v3json.itemMinCanReturnNum) {
          return
        }
        this.afterSaleForm.itemCanReturnNum -= 1
        this.checvaluev3()
      } else {
        if (this.afterSaleForm.itemCanReturnNum >= this.v3json.itemCanReturnNum) {
          return
        }
        this.afterSaleForm.itemCanReturnNum += 1
        this.checvaluev3()
      }
    },
    setitems(item, type, index) {
      console.log(item, type, index)
      return new Promise((resolve) => {
        const cacheData = cache.queryCache({
          // 获取缓存
          id: this.orderId + this.itemId,
          formId: 'addAfter'
        })
        this.refundIndex = type
        if (cacheData && cacheData.cacheDetails.refundTypeList.length) {
          this.afterSaleForm = cacheData.cacheParams
          // this.itemList = cacheData.cacheDetails.itemList // 缓存商品表格数据
          this.refundCommonReplaceDetail = cacheData.cacheDetails.refundCommonReplaceDetail // 缓存换货地址
          this.refundTypeList = cacheData.cacheDetails.refundTypeList // 缓存售后类型枚举
          this.receivedStatusList = cacheData.cacheDetails.receivedStatusList // 缓存货物状态枚举
          this.returnTypeList = cacheData.cacheDetails.returnTypeList // 缓存售后原因枚举
          this.isBarter = cacheData.cacheDetails.isBarter // 规格隐藏显示
          this.isReplenishment = cacheData.cacheDetails.isReplenishment // 补发商品规格和地址
          this.specificationOption = cacheData.cacheDetails.specificationOption // 缓存商品规格枚举
          this.itemId = cacheData.cacheDetails.itemId // 缓存默认选中
          this.refundDatas = cacheData.cacheDetails.refundDatas // 缓存售后类型参数
          this.v3json.itemCanReturnNum = cacheData.cacheDetails.itemCanReturnNum
          this.v3json.itemMinCanReturnNum = cacheData.cacheDetails.itemMinCanReturnNum
          this.listStatus = true
          return
        }
        this.afterSaleForm.refundType = ''
        this.afterSaleForm.receivedStatus = ''
        this.afterSaleForm.refundReasonList = ''
        this.afterSaleForm.itemCanReturnNum = 0
        // this.afterSaleForm.refundAmount = '0'
        this.afterSaleForm.dealtNote = ''
        this.afterSaleForm.operatorRefundImgs = []
        const datas = {
          orderId: item.orderId,
          frontRefundType: '',
          receivedStatus: '',
          refundReason: '',
          refundCommonApplyDetail: {
            barcode: item.barcode,
            subOrderId: item.subOrderId,
            returnNum: 0,
            deductionMoney: 0
          },
          version: 5
        }
        if (type === 2) {
          datas.refundCommonApplyDetail.refundCommonApplyTuDetailList = [
            {
              tuCode: item.barcode,
              subOrderId: item.subOrderId,
              barcode: item.itemList2[index].barcode,
              childOrderId: item.itemList2[index].subOrderId,
              returnNum: 0,
              deductionMoney: 0
            }
          ]
          this.oldBarcode = item.itemList2[index].barcode
          this.refundCommonReplaceDetail.itemId = item.itemList2[index].itemId
        } else {
          this.oldBarcode = item.barcode
          this.refundCommonReplaceDetail.itemId = item.itemId
        }
        this.refundDatas = datas
        http.toRefundCommonView(datas).subscribe((res) => {
          if (res.response.data.errorCode === 0) {
            const rulest = res.response.data
            this.cardCouponBeanList = rulest.data.cardCouponBeanList || [] // 卡券列表
            this.refundTypeList = rulest.data.frontRefundTypeList // 售后类型列表
            this.returnTypeList = rulest.data.refundReasonList // 售后原因列表
            this.receivedStatusList = rulest.data.receivedStatusList // 货物状态列表
            this.afterSaleForm.itemCanReturnNum = rulest.data.currentRefundNum // 当前售后数量
            this.afterSaleForm.returnMoney = rulest.data.returnMoney // 实退金额
            this.itemTotalPrice = rulest.data.itemTotalPrice
            this.totalAbleMoney = rulest.data.totalAbleMoney
            this.afterSaleForm.refundableMoney = rulest.data.refundableMoney // 应退金额
            this.afterSaleForm.returnTaxMoney = rulest.data.returnTaxMoney // 退税费
            this.afterSaleForm.wuliuFee = rulest.data.wuliuFee // 退物流费
            this.v3json.itemCanReturnNum = rulest.data.maxRefundNum // 当前最大可退数量
            this.v3json.itemMinCanReturnNum = rulest.data.minRefundNum // 当前最小可退数量
            this.returnMoneyDisable = rulest.data.returnMoneyDisable //禁用修改退款金额
            if (rulest.data.showCommissionOption) {
              this.afterSaleForm.notDeductCommission = rulest.data.notDeductCommission
                ? rulest.data.notDeductCommission
                : false // 是否扣减boss收益
              this.afterSaleForm.showCommissionOption = rulest.data.showCommissionOption // 是否展示boss收益
              // 不扣减收益按钮是否有修改权限 true：是 false：否(置灰)
              this.updateAuthDeductCommission = rulest.data.updateAuthDeductCommission
                ? rulest.data.updateAuthDeductCommission
                : false
            }
            this.listStatus = true
            this.fillZero = rulest.data.fillZero
            resolve()
          }
        })
      })
    },
    setRefundType(type, item) {
      if (type === 1) {
        this.afterSaleForm.receivedStatus = ''
        this.afterSaleForm.refundReasonList = ''
        this.isBarter = false
        this.isReplenishment = false
      }
      if (type === 2) {
        this.afterSaleForm.refundReasonList = ''
      }
      if (type === 3) {
        this.returnTypeList.forEach((v) => {
          if (v.refundReason === item) {
            this.refundYuanyin = v
          }
        })
      }
      if (type === 1 && item === 30) {
        this.isBarter = true
        this.isReplenishment = true
      } else if (type === 1 && item === 40) {
        this.isBarter = false
        this.isReplenishment = true
      }
      if (this.refundYuanyin.imgRequired && this.refundYuanyin.imgRequired === 1) {
        this.imgRequired = 'operatorRefundImgs'
      } else {
        this.imgRequired = ''
      }
      if (this.refundYuanyin.commentRequired && this.refundYuanyin.commentRequired === 1) {
        this.commentRequired = 'dealtNote'
      } else {
        this.commentRequired = ''
      }
      const datas = this.refundDatas
      datas.frontRefundType = this.afterSaleForm.refundType // 售后类型
      datas.receivedStatus = this.afterSaleForm.receivedStatus // 货物状态
      datas.refundReason = this.afterSaleForm.refundReasonList // 售后原因
      delete datas.realRefundMoneyAfter
      return new Promise((resolve, reject) => {
        http.toRefundCommonView(datas).subscribe((res) => {
          if (res.response.data.errorCode === 0) {
            const rulest = res.response.data
            this.cardCouponBeanList = rulest.data.cardCouponBeanList || [] // 卡券列表
            this.refundTypeList = rulest.data.frontRefundTypeList // 售后类型列表
            this.receivedStatusList = rulest.data.receivedStatusList // 货物状态列表
            this.afterSaleForm.itemCanReturnNum = rulest.data.currentRefundNum // 当前售后数量
            this.afterSaleForm.returnMoney = rulest.data.returnMoney // 实退金额
            this.itemTotalPrice = rulest.data.itemTotalPrice
            this.totalAbleMoney = rulest.data.totalAbleMoney
            this.afterSaleForm.refundableMoney = rulest.data.refundableMoney // 应退金额
            this.afterSaleForm.returnTaxMoney = rulest.data.returnTaxMoney // 退税费
            this.afterSaleForm.wuliuFee = rulest.data.wuliuFee // 退物流费
            this.v3json.itemCanReturnNum = rulest.data.maxRefundNum // 当前最大可退数量
            this.v3json.itemMinCanReturnNum = rulest.data.minRefundNum // 当前最小可退数量
            this.returnMoneyDisable = rulest.data.returnMoneyDisable //禁用修改退款金额
            if (type === 1 && item === 30) {
              this.specificationOption = rulest.data.refundCommonReplaceView.itemModelList // 商品规格列表
              this.afterSaleForm.address = rulest.data.refundCommonReplaceView.refundReceiverInfoVo // 地址
              this.refundCommonReplaceDetail.refundReceiverInfoVo = rulest.data.refundCommonReplaceView.refundReceiverInfoVo // 默认获取返回地址
            } else if (type === 1 && item === 40) {
              this.afterSaleForm.address = rulest.data.refundCommonReplaceView.refundReceiverInfoVo // 地址
              this.refundCommonReplaceDetail.refundReceiverInfoVo = rulest.data.refundCommonReplaceView.refundReceiverInfoVo // 默认获取返回地址
            }
            if (type !== 3) {
              this.returnTypeList = rulest.data.refundReasonList // 售后原因列表
            }
            this.afterSaleForm.notDeductCommission = rulest.data.notDeductCommission
              ? rulest.data.notDeductCommission
              : false // 是否扣减boss收益
            this.afterSaleForm.showCommissionOption = rulest.data.showCommissionOption
              ? rulest.data.showCommissionOption
              : false // 是否展示boss收益
            this.updateAuthDeductCommission = rulest.data.updateAuthDeductCommission
              ? rulest.data.updateAuthDeductCommission
              : false // 不扣减收益按钮是否有修改权限 true：是 false：否(置灰)
            this.fillZero = rulest.data.fillZero
            resolve()
          }
        })
      })
    },
    // getRefundCommonViewMoney 接口传入的数据
    getRefundCommonViewMoneyData() {
      const datas = this.refundDatas
      datas.refundCommonApplyDetail.returnNum = this.afterSaleForm.itemCanReturnNum
      if (this.refundIndex === 2) {
        datas.refundCommonApplyDetail.returnNum = 1
        datas.refundCommonApplyDetail.refundCommonApplyTuDetailList[0].returnNum = this.afterSaleForm.itemCanReturnNum
      }
      datas.version = 5
      delete datas.realRefundMoneyAfter
      return datas
    },
    checvaluev3() {
      const datas = this.getRefundCommonViewMoneyData()
      http.getRefundCommonViewMoney(datas).subscribe((res) => {
        this.afterSaleForm.returnMoney = res.data.returnMoney // 实退金额
        this.itemTotalPrice = res.data.itemTotalPrice
        this.totalAbleMoney = res.data.totalAbleMoney
        this.afterSaleForm.refundableMoney = res.data.refundableMoney // 应退金额
        this.afterSaleForm.notDeductCommission = res.data.notDeductCommission // 是否扣减boss收益
      })
    },
    handlePictureCardPreview(res) {
      if (res.errorCode === '0') {
        this.afterSaleForm.operatorRefundImgs.push(res.url)
      } else {
        this.$message.error(res.errorMessage || '文件上传失败')
      }
    },
    delbtnpic(index) {
      this.$confirm('是否确认删除图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.afterSaleForm.operatorRefundImgs.splice(index, 1)
      })
    },
    workImgs(val) {
      if (this.afterSaleForm.operatorRefundImgs && this.afterSaleForm.operatorRefundImgs.length >= 5) {
        this.$message.error('最多上传5张图片')
        return
      }
      if (val.split('http').length - 1 > 1) {
        this.$message.error('请上传正确的图片地址')
        return
      }
      this.afterSaleForm.operatorRefundImgs.push(val)
    },
    showimg(index) {
      this.$refs.viewerRef.$viewer.view(index)
    },
    // 获取退款明细数据
    getRefundAmountDetails() {
      if (
        this.afterSaleForm.refundType !== ''
        && this.afterSaleForm.returnMoney !== ''
        && this.afterSaleForm.returnMoney >= 0
      ) {
        const datas = this.getRefundCommonViewMoneyData()
        if (this.afterSaleForm.returnMoney < this.totalAbleMoney) {
          datas.realRefundMoneyAfter = this.afterSaleForm.returnMoney
        }
        http.getRefundCommonViewMoney(datas).subscribe((res) => {
          this.$refs.refundAmountDetails.handleData(res.data.refundDetailEquationBo || {})
        })
      } else {
        this.$message.error('请先选择售后类型以及填写正确的实退金额！')
      }
    },
    async injectGetOrderInfo(...args) {
      const [
        orderId,
        subOrderId,
        tuOrderId,
        fontRefundType,
        receivedStatus,
        refundReason,
        imgList
      ] = args
      this.afterSaleIsMoreThanAllowApplyTime(orderId)
      this.subOrderIdIdentify = tuOrderId || subOrderId
      const bool = await this.getOrderId(orderId, 1, subOrderId, tuOrderId)
      const cacheData = {
        cacheParams: {
          refundType: fontRefundType,
          receivedStatus,
          refundReasonList: refundReason
        }
      }
      this.getRefundApplyAutoFillPage(cacheData).then(async () => {
        this.afterSaleForm.refundType = fontRefundType
        await this.setRefundType(1, fontRefundType)
        this.afterSaleForm.receivedStatus = receivedStatus
        await this.setRefundType(2, receivedStatus)
        this.afterSaleForm.refundReasonList = refundReason
        await this.setRefundType(3, refundReason)
        this.afterSaleForm.operatorRefundImgs = imgList || []
      })
    },
    setFormData(data) {
      this.afterSaleForm.refundType = data.frontRefundType // 售后类型
      this.afterSaleForm.receivedStatus = data.receivedStatus // 售后状态
      this.afterSaleForm.refundReasonList = data.refundReason// 售后原因
      this.afterSaleForm.itemCanReturnNum = data.currentRefundNum // 当前售后数量
      this.afterSaleForm.returnMoney = data.returnMoney // 实退金额
      this.afterSaleForm.customerDesc = data.customerDesc// 原因描述
      this.afterSaleForm.notDeductCommission = data.notDeductCommission // boss收益
      this.afterSaleForm.refundableMoney = data.refundableMoney // 应退金额
      this.afterSaleForm.operatorRefundImgs = data.refundImgs || [] // 图片
      this.afterSaleForm.refundVideo = data.refundVideo ? JSON.parse(data.refundVideo) : { url: '', img: '' }// 视频
      this.afterSaleForm.cardCouponNoList = data.cardCouponNoList// 卡券收益
      this.afterSaleForm.specificationList = data.specificationList // 商品规格
      this.afterSaleForm.returnTaxMoney = data.returnTaxMoney // 退税费
      this.afterSaleForm.wuliuFee = data.wuliuFee // 退物流费
      Object.assign(this.afterSaleForm, data)
    }
  }
}
</script>
<style lang="less">
#addAfter {
  padding: 20px;
  background: white;
  border-top: 1px solid #dcdcdc;

  // .max-hei {
  //   max-height:750px;
  //   overflow: hidden;
  //   overflow-y: auto;
  // }
  .itemNumber {
    width: 70px;
    margin: 0 10px;

    .el-input__inner {
      text-align: center;
    }
  }

  .btns {
    margin: 2px 0 0 10px;
  }

  .goods-wrapper {
    margin: 10px 0;
    width: 500px;

    .el-radio__label {
      display: none;
    }

    .goods-list {
      display: flex;

      .left {
        width: 120px;
        padding: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
        border-bottom: 1px solid #dcdcdc;
      }

      .right {
        flex: 1;
        padding: 10px 0;
        border-right: 1px solid #dcdcdc;
        border-bottom: 1px solid #dcdcdc;
      }
    }

    .goods-list-header {
      background-color: rgba(240, 242, 245, 0.8);
      text-align: center;
    }

    .goods-info-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      text-align: left;

      img {
        width: 50px;
        height: 50px;
        margin: 0 10px;
        border: 1px solid #eee;
      }

      .goods-info {
        max-width: 70%;

        h4,
        p {
          span {
            display: inline-block;
            width: 270px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .identity_item {
          color: #ee2532;
          white-space: nowrap;
        }
      }

      .icon-wrapper {
        margin-left: 20px;
        font-size: 24px;
        cursor: pointer;
      }
    }
  }

  .googs_table {
    width: 100%;
    border-collapse: collapse;
    border: none;

    th {
      font-weight: bold;
    }

    td {
      display: flex;
      border-top: none !important;

      .elradio {
        // line-height:75px;
        line-height: 40px;
        font-size: 24px;
        padding-left: 5px;
        width: 30px;

        i {
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .active {
          transform: rotate(-90deg);
        }

        .el-radio {
          padding: 0 5px;
          margin: 0px;
        }
      }

      .centeradio {
        line-height: 75px;
      }
    }

    td,
    th {
      padding: 0px;
      border: 1px solid #dedede;
      text-align: center;
    }
  }

  .skill-input-wrapper .el-input,
  .skill-input-wrapper .el-form-item__content>.el-textarea {
    width: 360px !important;
  }

  // .skill-input-wrapper textarea{
  //   height:90px;
  // }
  .setlist {
    margin: 0;
    list-style: none;
    padding: 0;

    li {
      h4 {
        margin: 0 0 10px 0;
      }

      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;

      span {
        display: inline-block;
        margin-right: 30px;
      }
    }
  }

  .zengpin {
    position: absolute;
    left: 0px;
    top: 0px;
    background: #008000;
    color: white;
    width: 50px;
    text-align: center;
    margin: 0 10px;
  }

  .quedingshouhou {
    ul {
      margin: 0;
      list-style: none;

      li {
        position: relative;
        padding: 5px 0 15px 100px;
        border-top: 1px solid #ccc;
        height: 90px;

        img {
          position: absolute;
          left: 0;
          top: 50%;
          width: 60px;
          height: 60px;
          margin-top: -30px;
        }

        p {
          margin: 0;
          line-height: 1.8;
        }
      }
    }
  }

  .dialog-footer {
    text-align: center;
  }

  .edit {
    color: #1890ff;
    cursor: pointer;
  }

  .el-upload-dragger,
  .el-upload--picture-card {
    width: 70px;
    height: 70px;
    line-height: 78px;
  }

  .el-upload--picture-card {
    border: none;
  }

  .imgList {
    display: inline-block;

    span {
      position: relative;
      margin-right: 5px;
    }

    .el-icon-error {
      position: absolute;
      cursor: pointer;
      right: 0;
      background: #ccc;
    }

    img {
      width: 70px;
      height: 70px;
      border-radius: 5px;
      display: inline-block;
      border: 1px solid #eee;
    }
  }

  .el-select__tags+.el-input .el-input__inner {
    min-height: unset;
  }

  .question {
    font-size: 18px;
    vertical-align: middle;
    margin: 0 2px;
  }

  .upload-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .line-tip {
    line-height: 20px;
  }

  .upload-item {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    .text {
      line-height: 16px;
      font-size: 12px;
      color: #666;
    }
  }

  .el-icon-plus {
    margin-top: 12px;
    font-size: 20px;
    color: #8c939d;
  }
}
</style>
